import { ethers } from "ethers";
import { getCurrentContractAddresses } from "src/configs/address";
import MultiCallABI from "src/contract-logic/abis/MultiCallABI.json";
import { etherProviderHttp, web3Reader } from "src/wallet-connection";
import { keccak256 } from "web3-utils";

const multiCall = async (abi, calls, provider) => {
  const { MULTI_CALL_ADDRESS } = getCurrentContractAddresses();
  let _provider = provider || etherProviderHttp;
  const multi = new ethers.Contract(MULTI_CALL_ADDRESS, MultiCallABI, _provider);
  const itf = new ethers.utils.Interface(abi);

  const callData = calls.map((call) => [call.address.toLowerCase(), itf.encodeFunctionData(call.name, call.params)]);
  const { returnData } = await multi.aggregate(callData);
  return returnData.map((call, i) => itf.decodeFunctionResult(calls[i].name, call));
};

export default multiCall;

export function listenEvent(signature, eventInputPattern, logs) {
  if (logs) {
    const hexSignature = keccak256(signature);
    const correctLogs = logs.find((log) => log["topics"][0].toLowerCase() == hexSignature);
    if (correctLogs) {
      const decodeData = web3Reader.eth.abi.decodeLog(eventInputPattern, correctLogs.data, [hexSignature]);
      return decodeData;
    }
  }
  return undefined;
}
